import React, { FC, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { OrderProductImg } from '@cps'
import { each } from '@dt/fe-utils/dist/lodash'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps { orderInfo: any }

const OrderProduct: FC<IProps> = ({ orderInfo }) => {
  const info = useMemo(() => {
    const imgs = []
    const texts = []
    each(orderInfo.detailList, (item: any) => {
      if (item.parentId === '0') {
        texts.push(item.productName)
      }
    })
    each(orderInfo.pics, (item: any) => {
      const formatItem = format.toPic(item)
      imgs.push(formatItem?.url || '')
    })
    return {
      imgs,
      texts
    }
  }, [orderInfo])

  return (
    <div className='eval-order-product'>
      <div className='left'>
        <div className='order-img-list'>
          {
            info.imgs?.slice(0, 3).map((item, index) => {
              return (
                <div className='order-img' key={index}>
                  <OrderProductImg key={index} imgSrc={item} width={48} />
                </div>
              )
            })
          }
          {info.imgs?.length > 3 && <div className='orderlist-image-more'>...</div>}
        </div>
        <div className='order-pro-name'>{info.texts.join(',')}</div>
      </div>
    </div>
  )
}

export default observer(OrderProduct)
